import { newModel } from 'casbin';

export const model = newModel(`
[request_definition]
r = sub, obj, act

[policy_definition]
p = sub, obj, act, eft

[role_definition]
g = _, _

[policy_effect]
e = some(where (p.eft == allow)) && !some(where (p.eft == deny))

[matchers]
m = g(r.sub, p.sub) && keyMatch(r.obj, p.obj) && regexMatch(r.act, p.act)
`);

// p, admin, posts, (list) | (create)
// p, admin, posts/*, (edit)|(show)|(delete)
// p, admin, posts/*, field

export const defaultPermissions = `

// For Student
p, student, diagnostic_tools, (list)

// Announcements - superadmin only (CRUD)
p, superadmin, announcements, (list)|(create)|(edit)|(show)|(delete)
p, superadmin, announcements/*, (list)|(create)|(edit)|(show)|(delete)

// Global AI Usage - superadmin only
p, superadmin, global_ai_usage, (list)

// Live World Map - superadmin only
p, superadmin, live_world_map, (list)

// Assessments Calendar - superadmin only
p, superadmin, assessments_calendar, (list)

// Subject Merger - page-entry resource (route gate); per-tab resources gate
// tab visibility inside the page. See spec § Routing & navigation registration.
p, superadmin, subject_merger, (list)
p, support, subject_merger, (list)
p, superadmin, subject_merger_programme, (list)
p, superadmin, subject_merger_extras, (list)
p, superadmin, subject_merger_school, (list)
p, support, subject_merger_school, (list)

// What's New - superadmin, support, admin, teacher (read-only)
p, superadmin, whats_new, (list)|(show)
p, support, whats_new, (list)|(show)
p, admin, whats_new, (list)|(show)
p, teacher, whats_new, (list)|(show)

// Curriculum - superadmin only
p, superadmin, curriculum, (list)|(show)
p, superadmin, curriculum/*, (list)|(show)

// Gradebook v3 — FE-only resource. Visibility gated by enabledFeatures.gradebook_v3
// in resourcePermissions; legacy /gradebook deleted at LD1, gradebook_v3 GA.
// No BE permission row exists — BE permissions are still keyed on legacy "gradebook" —
// so every role that can use Gradebook needs an explicit FE policy here. Content
// authorization is enforced server-side by GradebookV3Policy regardless.
// Superadmin / support intentionally excluded — they don't use the gradebook
// surface in normal flows and we don't want it surfacing in their nav.
p, admin, gradebook-v3, (list)
p, teacher, gradebook-v3, (list)
p, qb_author, gradebook-v3, (list)
p, school_qb_author, gradebook-v3, (list)
p, district_qb_author, gradebook-v3, (list)
`;

// Policies active ONLY under the v4 shell (appended by the access-control
// provider's getEnforcer when resolveUiV4() is true — the shell can't change
// without a full reload, so the enforcer cache stays coherent).
//
// Help page (APL-11850 A3; comment updated APL-12040): /help is reachable by
// DIRECT URL ONLY — no nav points at it anymore. The sidebar Help entry
// (students + parents) goes straight to Zendesk via `meta.externalUrl`, and
// admin/teacher use the UserMenu help-center entry (also external Zendesk).
// The grants stay so the /help deep link keeps working for every role: the
// BE ships `help.list = false` for admin/teacher (v3-era decision), so this
// FE-side v4-only grant fills that gap; students/parents/superadmin/support
// already get `help.list = true` from the BE.
export const v4OnlyPermissions = `
p, admin, helps, (list)
p, teacher, helps, (list)
`;

// import { newModel, StringAdapter } from "casbin";

// export const model = newModel(`
//   [request_definition]
//   r = sub, obj, act

//   [policy_definition]
//   p = sub, obj, act

//   [role_definition]
//   g = _, _

//   [policy_effect]
//   e = some(where (p.eft == allow))

//   [matchers]
//   m = g(r.sub, p.sub) && keyMatch(r.obj, p.obj) && regexMatch(r.act, p.act)
// `);

// export const adapter = new StringAdapter(`
//   p, super_admin, users, manage
//   p, support, users, manage
//   p, admin, users, manage
//   p, teacher_admin, users, list
//   p, student, users, show
//   p, parent, users, (list)|(show)

//   p, editor, users, list
//   p, editor, canvases, (list)|(edit)
// `);
